<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 日志相关</el-breadcrumb-item>
                <el-breadcrumb-item>系统日志</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.traceId'
                                    clearable
                                    placeholder='请输入链路ID'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-input
                                    size='mini'
                                    v-model='queryParams.title'
                                    clearable
                                    placeholder='请输入标题'
                                    style='width: 240px'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.exceptionStatus' placeholder='异常状态'>
                                    <el-option
                                        :key='1'
                                        label='正常'
                                        :value='false'>
                                    </el-option>
                                    <el-option
                                        :key='2'
                                        label='发生异常'
                                        :value='true'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' filterable v-model='queryParams.projectName' placeholder='项目'>
                                    <el-option
                                        v-for='item in projectEnumList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.businessType' placeholder='业务类型'>
                                    <el-option
                                        v-for='item in businessTypeOptions'
                                        :key='item.label'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.operatorType'
                                           placeholder='操作终端'>
                                    <el-option
                                        v-for='item in operatorTypeOptions'
                                        :key='item.label'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-date-picker
                                    size='mini'
                                    v-model='timePicker.pickerTimeValue'
                                    type='daterange'
                                    align='right'
                                    unlink-panels
                                    range-separator='至'
                                    start-placeholder='开始日期'
                                    end-placeholder='结束日期'
                                    value-format='yyyy-MM-dd'
                                    @blur='handleTimePickerBlur'
                                    :picker-options='timePicker.pickerOptions'>
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-button v-if='batchDeleteStatus' type="danger" icon='el-icon-delete' size='mini' @click='handleBatchDelete'>批量删除</el-button>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='logInfoList'
                      @sort-change='handleSortChange'
                      @selection-change='handleSelectionChange'>
                <el-table-column align='center' type='selection' width='55' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='标题' prop='title' />
                <el-table-column :show-overflow-tooltip='true' width='100' align='center' label='接口发起者'
                                 prop='operator' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='项目' prop='projectName' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='业务类型'>
                    <template slot-scope='scope'>
                        <span>{{ computeBusinessType(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='接口'>
                    <template slot-scope='scope'>
                        <span>{{ computeRequestUri(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='操作终端'>
                    <template slot-scope='scope'>
                        <span>{{ computeOperatorType(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='链路ID'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.traceId }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='链路状态'>
                    <template slot-scope='scope'>
                        <el-tag type='danger' v-if='scope.row.exceptionStatus'>异常</el-tag>
                        <el-tag type='success' v-else>正常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='异常信息'>
                    <template slot-scope='scope'>
                        <span>{{computeExceptionTrack(scope.row)}}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' sortable='custom' label='创建时间' prop='createTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >详细
                        </el-button>
                        <el-button
                            icon='el-icon-warning-outline'
                            size='mini'
                            type='text'
                            @click='handleLogTraceChain(scope.row)'
                        >链路追踪
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='`${currentLogInfo.title} 接口详细数据`' :before-close='cancel' :visible.sync='open' append-to-body width='55%'>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>接口请求数据</span>
                    </div>
                    {{currentLogInfo.requestData}}
                </el-card>
                <br/>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>接口返回数据</span>
                    </div>
                    {{currentLogInfo.responseData}}
                </el-card>
                <br/>
                <el-card style='white-space: pre-line;max-height: 100vh;overflow-y: scroll;' class="box-card">
                    <div slot="header" class="clearfix">
                        <span>异常堆栈信息</span>
                    </div>
                    <div style='color: #f56c6c;'>
                        {{currentLogInfo.exceptionStackTrace}}
                    </div>
                </el-card>
                <div slot='footer' class='dialog-footer'>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog :title='`${currentLogInfo.title} 日志链路追踪`' :visible.sync='logTraceOpen' append-to-body width='55%'>
                <el-card style='white-space: pre-line;max-height: 60vh;overflow-y: scroll;' class="box-card">
                    <el-timeline>
                        <el-timeline-item :type='item.exceptionStatus ? "danger" : "success"' v-for='(item, index) in logExceptionTraceChain' :timestamp="`${item.title}   ${item.createTime}`" placement="top">
                            <el-card>
                                <el-collapse v-model="activeNames" @change="handleChange">
                                    <el-collapse-item v-if='item.requestData' title="请求数据" name="1">
                                        <div>{{item.requestData}}</div>
                                    </el-collapse-item>
                                    <el-collapse-item v-if='item.responseData' title="响应数据" name="2">
                                        <div>{{item.responseData}}</div>
                                    </el-collapse-item>
                                    <el-collapse-item v-if='item.exceptionStackTrace' title="异常堆栈" name="3">
                                        <el-card style='white-space: pre-line;max-height: 30vh;overflow-y: scroll;' class="box-card">
                                            <div style='color: #f56c6c;'>{{item.exceptionStackTrace}}</div>
                                        </el-card>
                                    </el-collapse-item>
                                </el-collapse>
                                <br/>
                                <el-descriptions :column='2'>
                                    <el-descriptions-item label="日志发起者">{{item.operator}}</el-descriptions-item>
                                    <el-descriptions-item label="项目">{{item.projectName}}</el-descriptions-item>
                                    <el-descriptions-item label="业务类型">{{item.businessType}}</el-descriptions-item>
                                    <el-descriptions-item label="操作终端">{{item.operatorType}}</el-descriptions-item>
                                </el-descriptions>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </el-card>
                <div slot='footer' class='dialog-footer'>
                    <el-button @click='logTraceOpen = false'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import { logApi } from '@/components/api/Log/log';

export default {
    name: 'GameDetail',
    components: { CottonFileUpload },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            logTraceOpen: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [],
                
                businessType: undefined,
                operatorType: undefined,
                traceId: undefined,
                projectName: undefined,
                exceptionStatus: undefined,
                operator: undefined,
                title: undefined,
                startTime: undefined,
                endTime: undefined
            },
            currentLogInfo: {},
            logInfoList: [],
            businessTypeOptions: [
                {
                    label: '新增操作',
                    value: 'INSERT'
                },
                {
                    label: '修改操作',
                    value: 'UPDATE'
                },
                {
                    label: '删除操作',
                    value: 'DELETE'
                },
                {
                    label: '查询操作',
                    value: 'QUERY'
                },
                {
                    label: '其他',
                    value: 'OTHER'
                },
            ],
            operatorTypeOptions: [
                {
                    label: '管理后台',
                    value: 'MANAGE'
                },
                {
                    label: '游戏客户端',
                    value: 'GAME_CLIENT'
                },
                {
                    label: '其他',
                    value: 'OTHER'
                }
            ],
            
            projectEnumList: [],
            
            logExceptionTraceChain: [],
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            }
        };
    },
    created() {
        this.getList();
    },
    computed: {
        convertLogJsonStr() {
            return (jsonStr) => {
                if (!jsonStr) {
                    return jsonStr
                }
                let parse = JSON.parse(jsonStr);
                return JSON.stringify(parse, null, 2)
            }
        },
        computeBusinessType() {
            return (row) => {
                for (let i = 0; i < this.businessTypeOptions.length; i++) {
                    if (row.businessType === this.businessTypeOptions[i].value) {
                        return this.businessTypeOptions[i].label;
                    }
                }
            };
        },
        computeRequestUri() {
            return (row) => {
                if (!row.requestMethod) {
                    return '';
                }
                return `${row.requestMethod}:${row.requestUri}`;
            };
        },
        computeOperatorType() {
            return (row) => {
                for (let i = 0; i < this.operatorTypeOptions.length; i++) {
                    if (row.operatorType === this.operatorTypeOptions[i].value) {
                        return this.operatorTypeOptions[i].label;
                    }
                }
            };
        },
        computeExceptionTrack() {
            return (row) => {
                if (row.exceptionStackTrace) {
                    return row.exceptionStackTrace.substring(0, row.exceptionStackTrace.indexOf("\n"))
                }else {
                    return ''
                }
            }
        }
    },
    methods: {
        /** 查询字典类型列表 */
        getList() {
            this.reset()
            this.loading = true;
            logApi.queryLog(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.logInfoList = result.data.result;
                    this.queryParams.total = result.data.total;
                    this.loading = false;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize
                } else {
                    this.loading = false;
                }
            })
            
            
            // 查询项目枚举
            logApi.queryProjectNameList().then(result => {
                if (result.code === 200) {
                    result.data.forEach(project => {
                        this.projectEnumList.push({
                            label: project,
                            value: project
                        });
                    });
                }
            });
        },
        /** 提交按钮 */
        async submitForm() {
        
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return logApi.deleteLog({batchDeleteIdList: [row.id]});
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        async handleSortChange({column, prop, order}) {
            let sortType = null
            if (order === "ascending") {
                sortType = "ASC"
            }else if (order === "descending") {
                sortType = "DESC"
            }
            
            let newSortSql = prop + " " + sortType
            if (this.queryParams.sortSqlList.length > 0) {
                let sortAddStatus = false
                for (let i = 0; i < this.queryParams.sortSqlList.length; i++) {
                    let sortSql = this.queryParams.sortSqlList[i]
                    if (sortSql.indexOf(prop) !== -1) {
                        // 存在排序sql
                        this.queryParams.sortSqlList.splice(i, 1)
                        if (order) {
                            this.queryParams.sortSqlList.push(newSortSql)
                        }
                        sortAddStatus = true
                    }
                    if (i === this.queryParams.sortSqlList.length - 1) {
                        if (!sortAddStatus) {
                            this.queryParams.sortSqlList.push(newSortSql)
                        }
                    }
                }
            }else {
                this.queryParams.sortSqlList.push(newSortSql)
            }
            this.getList()
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList()
        },
        // 表单重置
        reset() {
            this.projectEnumList = []
            this.logInfoList = []
            this.currentLogInfo = {}
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.queryParams.sortSqlList = []
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
        
        },
        handleBatchDelete() {
            let idList = this.ids;
            let obj = this
            this.$modal.confirm('是否确认删除"' + this.ids.length + '"条日志？').then(function() {
                return logApi.deleteLog({batchDeleteIdList: obj.ids});
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    obj.$modal.msgSuccess('批量删除成功');
                }
            }).catch(() => {
            });
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.currentLogInfo = row
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size
            this.getList()
        },
        // 根据traceId查询链路
        handleLogTraceChain(row) {
            this.currentLogInfo = row;
            this.logExceptionTraceChain = [];
            this.logTraceOpen = true;
            logApi.queryLog({
                pageNum: 1,
                pageSize: 1000000,
                traceId: row.traceId,
                sortSqlList: ['createTime ASC']
            }).then(result => {
                if (result.code === 200) {
                    this.logExceptionTraceChain = result.data.result;
                }
            });
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return;
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + ' 00:00:00';
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + ' 23:59:59';
        }
    },
};
</script>
<style>

</style>
